/** @format */

import { useMutation } from '@apollo/client';
import {
  UPDATE_CAMPAIGN,
  UpdateCampaignData,
  UpdateCampaignVariables,
  UpdateCampaignInput,
} from '../services/getCampaigns';

interface UseUpdateCampaignReturn {
  updateCampaign: (id: string, input: UpdateCampaignInput) => Promise<void>;
  loading: boolean;
  error: string | null;
}

/**
 * Custom hook for updating a campaign
 */
export const useUpdateCampaign = (): UseUpdateCampaignReturn => {
  const [mutate, { loading, error }] = useMutation<
    UpdateCampaignData,
    UpdateCampaignVariables
  >(UPDATE_CAMPAIGN);

  const updateCampaign = async (id: string, input: UpdateCampaignInput): Promise<void> => {
    await mutate({
      variables: { id, input },
    });
  };

  return {
    updateCampaign,
    loading,
    error: error?.message || null,
  };
};
